import client from 'lib/sitecore-client';

/**
 * Gets an Item.
 *
 * @param {string} query - Query to be executed.
 * @param {string} path - Either the full item path or ShortID.
 * @param {string} language - Optional - the item language version you need. Default is en.
 * @returns {T} The item type requested.
 */
export async function getItem<T>(query: string, path: string, language = 'en') {
  try {
    const response = await client?.getData<T>(query, {
      path: path,
      language,
    });
    if (response) {
      return response;
    }
  } catch (error) {
    console.warn('There was a critical error getting item via graphql.', error);
  }

  return null;
}
